export enum PosthogFeatureFlag {
  TASKS_SYSTEM = 'tasks_system',
  BTL_CASE_SIDEBAR = 'btl_case_sidebar',
  OO_CASE_NEW_UI = 'oo_case_new_ui',
  OO_CASE_NEW_SECTIONS = 'oo_case_new_sections',
  OO_CASE_SOLICITORS = 'oo_case_solicitors',
  OO_CASE_DIP_ACCEPTED_EDIT = 'oo_case_dip_accepted_edit',
  OO_CASE_CREATE_FLOW = 'oo_case_create_flow',
  OO_CASE_SUBMISSION = 'oo_case_submission',
  HPP_PERMISSIONED_PAGES = 'hpp_permissioned_pages',
}
